import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { agentsApi } from '../../constants/agents-api';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { specificUserParams, userParams } from '../../helpers/helperfunc';

@Injectable({
    providedIn: 'root'
})
export class AgentsService {
    permissions_entity = permissionEntity;

    constructor(
        private httpClientService: HttpClientService,
        private _permissionPipe: PermissionsPipe // dont remove this
    ) { }

    getAgents(pagination: PaginationType, filters?: any, search?: string, tenant_id?: any, sort: {sortDataOption:string, sortDataOrder:string} = null, searchkey: string ='company'): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (tenant_id) {
            query += `tenantId=${tenant_id}&`;
        }
        if (search) {
            query += `${searchkey}=${search}&`;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        query += userParams.call(this, this.permissions_entity.modules.agents);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        return this.httpClientService.get(`${agentsApi.getAgents}${query}`);
    }
    getSearchAgents(pagination: PaginationType, filters?: any, search?: string, tenant_id?: any, sort: {sortDataOption:string, sortDataOrder:string} = null, searchkey: string ='company'): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (tenant_id) {
            query += `tenantId=${tenant_id}&`;
        }
        if (search) {
            query += `${searchkey}=${search}&`;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        query += userParams.call(this, this.permissions_entity.modules.agents);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        return this.httpClientService.get(`${agentsApi.searchAgent}${query}`);
    }

    getAgentsNonApproved(
        pagination: PaginationType,
        filters?: any,
        search?: string,
        tenant_id?: any,
        sort: { sortDataOption: string, sortDataOrder: string } = null
        ): Observable<any> {
        let query = '?';
        let hasStatus = false;

        if (filters) {
            hasStatus = /(^|&)status=/.test(filters); // checks for status= at start or after &
            query += filters;
        }

        if (tenant_id) {
            query += `tenantId=${tenant_id}&`;
        }
        if (search) {
            query += `company=${search}&`;
        }
        if (sort) {
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        query += userParams.call(this, this.permissions_entity.modules.agents);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        // Only append default status if not present in filters
        if (!hasStatus) {
            query += (query.endsWith('?') ? '' : '&') + 'status=new,pending';
        }

        return this.httpClientService.get(`${agentsApi.getAgents}${query}`);
    }

    getAllAgents(): Observable<any> {
        return this.httpClientService.get(`${agentsApi.getAgents}`);
    }

    postAgents(payload: any): Observable<any> {
        return this.httpClientService.post(
            agentsApi.createAgents,
            payload
        );
    }

    editAgents(payload: any, agentsId: string): Observable<any> {
        const url = `${agentsApi.editAgents}?id=${agentsId}`;
        return this.httpClientService.put(url, payload);
    }

    getEditAgent(agentsId: string): Observable<any> {
        const url = `${agentsApi.getAgents}/details?Id=${agentsId}`;
        return this.httpClientService.get(url);
    }

    deleteAgents(): Observable<any> {
        return this.httpClientService.delete(agentsApi.deleteAgents);
    }

    agentApproval(payload: any): Observable<any> {
        return this.httpClientService.upload(
            agentsApi.approveAgents,
            payload
        );
    }

    resendInvite(id: string): Observable<any> {
        return this.httpClientService.post(agentsApi.resendInvite.replace(':userId', id), {});
    }

    deleteAgent(id: string, status: any): Observable<any> {
        const url = `${agentsApi.deleteAgents}?status=${status}&id=${id}`;
        return this.httpClientService.delete(url);
    }

    getAppliedFilters() {
        let applied_filter = JSON.parse(localStorage.getItem('agents_applied_filter') || '[]');
        let applied_filter_count = applied_filter.length ? applied_filter.length : null;

        return { applied_filter, applied_filter_count };
    }

    getAgentUploadDoc(pagination: PaginationType, agent_id: any): Observable<any> {
        return this.httpClientService.get(`${agentsApi.getAgentDoc}${agent_id}&skip=${pagination.skip}&limit=${pagination.limit}`);
    }

    uploadDoc(agent_id: any, payload: any) {
        const url = `${agentsApi.uploadAgentDoc}${agent_id}`;
        return this.httpClientService.upload(url, payload);
    }

    getAgentUploadDocById(pagination: PaginationType, agentId: string): Observable<any> {
        return this.httpClientService.get(`${agentsApi.getAgentDoc}${agentId}&skip=${pagination.skip}&limit=${pagination.limit}`);
    }

    uploadDocById(id: any, payload: any) {
        const url = `${agentsApi.uploadAgentDoc}${id}`;
        return this.httpClientService.upload(url, payload);
    }

    getAgentLogs(pagination: PaginationType, agent_id: any): Observable<any> {
        return this.httpClientService.get(`${agentsApi.getAgentLogs.replace(':agentId',agent_id)}&skip=${pagination.skip}&limit=${pagination.limit}`);
    }

    approvePayment(paymentID, status, agentId): Observable<any> {
        return this.httpClientService.post(`${agentsApi.agentBankDetails}${paymentID}${status?`&status=${status}`:''}${agentId?`&agentId=${agentId}`:''}`,{});
    }

    getBankdetailsList(agentId: any, payload: any): Observable<any> {
        return this.httpClientService.post(`${agentsApi.agentBankDetails}${agentId}`, payload);
    }

    // Approved Agent, Non Approved, Pending Bank, Inactive API Service
    getAgentsApproved(pagination: PaginationType, filters?: any, search?: string, tenant_id?: any, sort: any = null): Observable<any> {
        console.log(filters,'filters')
        // console.log(sort);
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (tenant_id) {
            query += `tenantId=${tenant_id}&`;
        }
        if (search) {
            query += `search=${search}&`;
        }
        if (sort) {
            query += `sortData=${sort}&`;
        }
        query += userParams.call(this, this.permissions_entity.modules.agents);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        // console.log(query);

        return this.httpClientService.get(`${agentsApi.getAgents}${query}`);
    }

    updateTag(fileId, tagName): Observable<any> {
        return this.httpClientService.put(`${agentsApi.updateLabel.replace(':labelName',tagName).replace(":fileId",fileId)}`,{});
    }

    getMouForAgents(payload: any): Observable<any> {
        return this.httpClientService.post(`${agentsApi.getMouForAgents.replace(':tenantId',payload?.tenantId).replace(':agentId',payload?.agentId)}`, {});
    }

    // universityBlack(payload: any, agentId: string): Observable<any> {
    //     // Construct your API endpoint
    //     const endpoint = `${this.apiUrl}/agents/${agentId}/university-blacklist`; // Replace with your actual API endpoint
    
    //     // Make the POST request and return the Observable
    //     return this.httpClientService.put<any>(endpoint, payload);
    //   }

      universityBlack(payload: any, agentsId: string): Observable<any> {
        const url = `${agentsApi.uniBlacklist}?id=${agentsId}`;
        // const url = `${agentsApi.uniBlacklist}?id=1317`;
        return this.httpClientService.put(url, payload);
    }

    getuniversityBlack(pagination: PaginationType, agentsId: string): Observable<any> {
        const url = `${agentsApi.uniBlacklist}?id=${agentsId}`;
        // const url = `${agentsApi.uniBlacklist}?id=1317`;
        return this.httpClientService.put(url, '');
    }

    postAgentRating(payload:any): Observable<any> {
        return this.httpClientService.post(agentsApi.postAgentRating, payload);
    }
    
    getAgentRating(agentId: string): Observable<any> {
        return this.httpClientService.get(`${agentsApi.getAgentRating}${agentId}`);
    }

    getReports(pagination, filters): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        // if (tenant_id) {
        //     query += `tenantId=${tenant_id}&`;
        // }
        // if (search) {
        //     query += `company=${search}&`;
        // }
        // if (sort) { ///? for sorting
        //     query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        // }
        // query += userParams.call(this, this.permissions_entity.modules.agents);
        query += `&skip=${pagination.skip}&limit=${pagination.limit}`;

        return this.httpClientService.get(`${agentsApi.getReports}${query}`);
        
    }

    getPaymentRating(pagination, filters?: any,agentId?: string): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`
        return this.httpClientService.get(`${agentsApi.getPaymentDetails}${query}`);
    }
    getFineList(pagination,id){
         let query = '&';
        query += `skip=${pagination.skip}&limit=${pagination.limit}`
        return this.httpClientService.get(`${agentsApi.getFineList}${id}${query}`);
    }
    updateFineAmount(payload:any,id): Observable<any> {
        return this.httpClientService.put(`${agentsApi.updateFineAmount}${id}`, payload); 
    }
    addFineAmount(payload:any,id): Observable<any> {
        return this.httpClientService.put(`${agentsApi.addFineAmount}${id}`, payload); 
    }
    getAgentPaymentDetails(): Observable<any> {
        return this.httpClientService.get(`${agentsApi.getAgentPaymentDetails}`);
    }  
    
    resetAgentPassword(payload: any): Observable<any> {
        return this.httpClientService.post(agentsApi.resetAgentPassword, payload);
    }
    getReferrers(): Observable<any> {
        return this.httpClientService.get(`${agentsApi.getReferrers}`);
    }
    getMarketingManager(): Observable<any> {
        return this.httpClientService.get(`${agentsApi.getMarketingManager}`);
    }
    getSource(): Observable<any> {
        return this.httpClientService.get(`${agentsApi.sourceAgent}`);
    }

    addPartners(payload: any): Observable<any> {
        return this.httpClientService.post(agentsApi.addPartners, payload);
    }

    getPartners(pagination: PaginationType, filters?: any, search?: string, sort: {sortDataOption:string, sortDataOrder:string} = null): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (search) {
            query += `search=${search}&`;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        query += userParams.call(this, this.permissions_entity.modules.partners);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        return this.httpClientService.get(`${agentsApi.getPartners}${query}`);
    }

    getPartnerById(partnerId: string): Observable<any> {
        const url = `${agentsApi.getPartners}/details?Id=${partnerId}`;
        return this.httpClientService.get(url);
    }

    getAccommodation(pagination: PaginationType, filters?: any, search?: string): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (search) {
            query += `search=${search}&`;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(`${agentsApi.getAccommodation}${query}`);
    }

    getAccommodationEnquiryList(pagination: PaginationType, filters?: any, search?: string): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (search) {
            query += `search=${search}&`;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(`${agentsApi.getAccommodationEnquiryList}${query}`);
    }

    getLoanEnquiryList(pagination: PaginationType, filters?: any, search?: string): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (search) {
            query += `search=${search}&`;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(`${agentsApi.getLoanEnquiryList}${query}`);
    }

}
